import Header from './Header';

export default Header;



// WEBPACK FOOTER //
// ./src/components/ProductPage/components/Header/index.js